import React, { useContext, useState, useEffect } from "react";
import {
    Button, Toolbar, Typography, IconButton, Dialog, AppBar, Slide, Container, Table, TableRow, TableCell, TableHead, TableBody, TextField
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles';
import { Row, Col } from "react-bootstrap";
import AuthContext from '../../context/auth-context'
import mZona from './Zona.controller'
import moment from 'moment'
import { isArray } from 'util'
import DeleteIcon from '@material-ui/icons/Delete';
// import { array } from "prop-types";
// import DialogInfo from '../../Dialog/DialogInfo'
import validate from 'validate.js';

var dateNow = moment();
// const tgl = dateNow.format("YYMMDDHHmmss")
const DialogEditzona = (props) => {
    const classes = useStyles();
    const kodezona = props.item
    const kodeoutlet = props.kodeoutlet
    const { clientID, token } = useContext(AuthContext)
    const [addRow, setAddRow] = useState(dateNow.format("YYMMDDHHmmss") * 1 + 0)
    const [listZona, setListZona] = useState([])
    // const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    // const [dialogtext, setDialogtext] = useState()

    const handleClose = () => {
        props.setOpen(false);
    }
    const SimpanZona = () => {
        const validasiError = []
        listZona.map(el => {
            const { namazona } = el;
            const constraint = {
                namazona: {
                    length: {
                        minimum: 3,
                        message: "Nama Zona minimal terdiri dari 3 huruf"
                    },
                }
            }
            const validator = validate({ namazona }, constraint, { fullMessages: false });
            if (validator) {
                const err = [validator][0]
                const keys = Object.keys(err);
                var errorMessage = "";
                for (const key of keys) {
                    errorMessage += err[key] + "\n";
                }
                validasiError.push(errorMessage)
                return
            }
        })
        if (validasiError.length > 0) return alert(validasiError[0])
        mZona.importZona(kodeoutlet, listZona, clientID, token).then(resp => {
            //  setIsLoading(false);
            if (resp) {
                alert("Data Berhasil Di Simpan")
                props.setOpen(false);
                props.setIsRefresh(true);
                props.setSelected([])
                props.notif()
            } else {
                alert("Data Gagal Di Simpan")
            }
        }).catch(err => {
            if (isArray(err) && err.length > 0) {
                alert(`Gagal Simpan :  ${err[0].message}`)
            } else if (typeof err == 'error') {
                alert(err.message)
            } else {
                console.log(err);
            }
        })
    }
    const handleaddRow = () => {
        setAddRow(addRow + 1)
        setListZona([
            ...listZona,
            {
                kodezona: addRow,
                namazona: "",
                tarifongkir: 0,
                isInsert: true
            }
        ])
    }

    useEffect(() => {
        if (kodezona == null) {
            setAddRow(addRow + 1)
            setListZona([
                {
                    kodezona: addRow,
                    namazona: "",
                    tarifongkir: 0,
                    isInsert: true
                }
            ])
        } else {
            var render = true
            mZona.getData(kodeoutlet, clientID, token, kodezona).then(resp => {
                if (render) setListZona(resp);
            }).catch(err => {
                console.error(err);
            })
            return () => {
                render = false
            };
        }

    }, [kodeoutlet, clientID, token]);
    const handleChange = (ev, kodezona) => {
        var value = ev.target.value;
        const key = ev.target.id || ev.target.name;
        let b = listZona.map(el => {
            if (el.kodezona === kodezona) {
                if (key === "namazona") {
                    return {
                        ...el,
                        namazona: value
                    }
                } else if (key === "kodezona") {
                    return {
                        ...el,
                        kodezona: value,
                    }
                }
                else if (key === "tarifongkir") {
                    return {
                        ...el,
                        tarifongkir: value,
                    }
                }
            } else return el
        })
        setListZona(b)
    }
    const deleteRow = (data) => {
        let a = listZona.filter(el => {
            return el.kodezona !== data.kodezona
        })
        setListZona(a)
    }
    return (
        <Dialog fullScreen open={props.open} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="close" onClick={handleClose} >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Edit Zona</Typography>
                    <Button color="inherit" onClick={SimpanZona}>
                        save</Button>
                </Toolbar>
            </AppBar>
            <Container className="DialogFont bodyDialog">
                <Row className={classes.root}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className="colorWhite" style={{ minWidth: ' 250px' }}>Kode Zona</TableCell>
                                <TableCell className="colorWhite" style={{ minWidth: ' 350px' }}>Nama zona</TableCell>
                                <TableCell className="colorWhite" style={{ minWidth: ' 350px' }}>Tarif Ongkir</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listZona.map((data, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row" className="colorWhite">
                                            {!data.isInsert && (data.kodezona)}
                                            {data.isInsert && (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col xs={2} md={1}>
                                                            <DeleteIcon className="deleteDialog" onClick={deleteRow.bind(this, data)} />
                                                        </Col>
                                                        <Col xs={10} md={11}>
                                                            <span className="tabelForm">
                                                                <TextField
                                                                    id="kodezona"
                                                                    name="kodezona"
                                                                    label=""
                                                                    fullWidth
                                                                    required
                                                                    multiline={false}
                                                                    value={data.kodezona}
                                                                    variant="outlined"
                                                                    onChange={(ev) => handleChange(ev, data.kodezona)}
                                                                />
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="namazona"
                                                name="namazona"
                                                label=""
                                                fullWidth
                                                required
                                                multiline={false}
                                                value={data.namazona}
                                                variant="outlined"
                                                onChange={(ev) => handleChange(ev, data.kodezona)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="tarifongkir"
                                                name="tarifongkir"
                                                label=""
                                                fullWidth
                                                required
                                                multiline={false}
                                                value={data.tarifongkir}
                                                variant="outlined"
                                                onChange={(ev) => handleChange(ev, data.kodezona)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Row>
                <Row>
                    <Button className="marginTop15" variant="contained" color="primary" component="span" onClick={handleaddRow}>Add Row</Button>
                    {/* <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} /> */}
                </Row>
            </Container>
        </Dialog>
    )
}
export default DialogEditzona;
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(1),
        overflowX: 'auto',
        overflowY: 'hidden',
    },
}));